import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import kaptionAccessTokensAPI from '../../api/kaptionAccessTokens';

const state = {
  records: [],
  kaptionAssistants: [],
  scopes: {},
  roles: {},
  accounts: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
    fetchingAssistants: false,
    fetchingScopes: false,
  },
};

export const getters = {
  getTokens(_state) {
    return _state.records.sort((t1, t2) => t2.id - t1.id);
  },
  getToken: _state => id => {
    return _state.records.find(token => token.id === Number(id));
  },
  getKaptionAssistants(_state) {
    return _state.kaptionAssistants;
  },
  getScopes(_state) {
    return _state.scopes;
  },
  getRoles(_state) {
    return _state.roles;
  },
  getAccounts(_state) {
    return _state.accounts;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      fetchingList: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.getAll();
      commit(types.default.SET_KAPTION_ACCESS_TOKENS, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  async show({ commit }, id) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      fetchingItem: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.get(id);
      commit(types.default.UPDATE_KAPTION_ACCESS_TOKEN, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        fetchingItem: false,
      });
    }
  },

  async create({ commit }, params) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      creatingItem: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.create(params);
      commit(types.default.ADD_KAPTION_ACCESS_TOKEN, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.update(id, updateObj);
      commit(types.default.UPDATE_KAPTION_ACCESS_TOKEN, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async revoke({ commit }, id) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      deletingItem: true,
    });
    try {
      await kaptionAccessTokensAPI.revoke(id);
      commit(types.default.DELETE_KAPTION_ACCESS_TOKEN, id);
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        deletingItem: false,
      });
    }
  },

  async rotate({ commit }, id) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.rotate(id);
      commit(types.default.DELETE_KAPTION_ACCESS_TOKEN, id);
      commit(types.default.ADD_KAPTION_ACCESS_TOKEN, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async fetchKaptionAssistants({ commit }) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      fetchingAssistants: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.getKaptionAssistants();
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_ASSISTANTS, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        fetchingAssistants: false,
      });
    }
  },

  async fetchRoles({ commit }) {
    try {
      const response = await kaptionAccessTokensAPI.getRoles();
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_ROLES, response.data);
    } catch (error) {
      // Handle error silently
    }
  },
  async fetchScopes({ commit }) {
    commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
      fetchingScopes: true,
    });
    try {
      const response = await kaptionAccessTokensAPI.getScopes();
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_SCOPES, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG, {
        fetchingScopes: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_KAPTION_ACCESS_TOKEN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_KAPTION_ACCESS_TOKENS]: MutationHelpers.set,
  [types.default.ADD_KAPTION_ACCESS_TOKEN]: MutationHelpers.create,
  [types.default.UPDATE_KAPTION_ACCESS_TOKEN]: MutationHelpers.update,
  [types.default.DELETE_KAPTION_ACCESS_TOKEN]: MutationHelpers.destroy,
  [types.default.SET_KAPTION_ACCESS_TOKEN_ASSISTANTS](_state, data) {
    _state.kaptionAssistants = data;
  },
  [types.default.SET_KAPTION_ACCESS_TOKEN_ROLES](_state, data) {
    _state.roles = data.roles || {};
    _state.accounts = data.accounts || [];
  },
  [types.default.SET_KAPTION_ACCESS_TOKEN_SCOPES](_state, data) {
    _state.scopes = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
